// extracted by mini-css-extract-plugin
export default {"popup-menu":"PopupMenu_popup-menu__900sV","item":"PopupMenu_item__JYZ9b"};